import { useEffect } from 'react';

/**
 * Calls `onEscape` when the Escape key is pressed, while `enabled` is true.
 * Used to let popups, modals, and slideouts be dismissed with <Esc>.
 */
export function useEscapeKey(enabled: boolean, onEscape: () => void) {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onEscape();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [enabled, onEscape]);
}
